module.exports = __webpack_public_path__ + "6acb6f14242679e1652c89d302a8ff83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/professional_h128.png
// module id = 322
// module chunks = 1